<script setup lang="ts">
import { Button } from "@/components/ui"
import BaseModalReka from "@/components/ui/BaseModalReka/BaseModalReka.vue"
import { useTranslation } from "@/composables"

defineProps<{
  open: boolean
}>()

const emit = defineEmits<{
  "update:open": [value: boolean]
}>()

const { t } = useTranslation()

const steps = [
  {
    title: t("install_banner.ios_modal.step_1"),
    message: t("install_banner.ios_modal.step_1_message"),
  },
  {
    title: t("install_banner.ios_modal.step_2"),
    message: t("install_banner.ios_modal.step_2_message"),
  },
  {
    title: t("install_banner.ios_modal.step_3"),
    message: t("install_banner.ios_modal.step_3_message"),
  },
]
</script>

<template>
  <BaseModalReka :open="open" :title="t('install_banner.ios_modal.title')" @update:open="emit('update:open', $event)">
    <div class="p-6 max-w-md mx-auto bg-white rounded-lg">
      <div class="text-center mb-6">
        <h2 class="text-xl font-bold mb-2">
          {{ t("install_banner.ios_modal.title") }}
        </h2>
        <p class="text-label">
          {{ t("install_banner.ios_modal.message") }}
        </p>
      </div>

      <div class="space-y-4">
        <div v-for="(step, index) in steps" :key="step.title">
          <div class="flex items-start gap-3">
            <div class="shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold text-sm">
              {{ index + 1 }}
            </div>
            <div>
              <h3 class="font-semibold">
                {{ step.title }}
              </h3>
              <p class="text-sm text-label">
                {{ step.message }}
              </p>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center">
          <Button class="w-full mt-6" @click="emit('update:open', false)">
            {{ t("install_banner.ios_modal.got_it_btn") }}
          </Button>
        </div>
      </div>
    </div>
  </BaseModalReka>
</template>
